import { toRef, openBlock, createElementBlock, normalizeClass, createTextVNode, toDisplayString, createCommentVNode, createBlock, resolveDynamicComponent, mergeProps, unref, toHandlers, withCtx, renderSlot, withDirectives, createElementVNode, vShow, computed, toRefs, ref, reactive, Fragment, renderList, createVNode, createSlots, vModelCheckbox } from 'vue';
import axios from 'axios';
import { useField, useForm } from 'vee-validate';
import { getFirestore, collection, serverTimestamp, addDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import * as Yup from 'yup';

var defaultConfig = {
  apiKey: 'AIzaSyCJY9hwrkNh3dbtRGblGi9MKMRNfuF6s-w',
  authDomain: 'forest-flow.firebaseapp.com',
  projectId: 'forest-flow',
  storageBucket: 'forest-flow.appspot.com',
  messagingSenderId: '949316691285',
  appId: '1:949316691285:web:5f10318d184b0aed82bbdc',
};

const firebaseApp = initializeApp(defaultConfig);

// used for the firestore refs
const db = getFirestore(firebaseApp);

const getFirebaseCollection = (collectionName) => {
  if (collectionName) {
    return collection(db, collectionName);
  }

  return collection(db, 'contactoForm');
};

// export default getFirebaseCollection

const _hoisted_1$2 = ["for"];
const _hoisted_2$2 = {
  key: 0,
  class: "text-danger pl-2"
};
const _hoisted_3$2 = {
  key: 1,
  class: "text-muted"
};


var script$2 = {
  __name: 'DynamicInput',
  props: {
  as: {
    type: [String, Object],
    default: undefined,
  },
  type: {
    type: String,
    default: 'text',
  },
  name: {
    type: String,
    required: true,
  },
  labelText: {
    type: String,
    default: '',
  },
  multiple: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  formRef: {
    type: String,
    default: 'FormBuilder',
  },
  rules: {
    type: [Object, String, Function],
    default: undefined,
  },
  classes: {
    type: String,
    default: '',
  },
  instructions: {
    type: String,
    default: '',
  },
  successMessage: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  bigField: {
    type: Boolean,
    default: false,
  },
  bigForm: {
    type: Boolean,
    default: false,
  },
  isFeedBackTooltip: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

// use `toRef` to create reactive references to `name` prop which is passed to `useField`
// this is important because vee-validte needs to know if the field name changes
// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
const name = toRef(props, 'name');
const rules = toRef(props, 'rules');
const {
  value: inputValue,
  errorMessage,
  handleChange,
  handleBlur,
  meta,
} = useField(name, rules, {
  initialValue: props.value,
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["position-relative mb-5", __props.classes])
  }, [
    (__props.labelText !== '')
      ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: "form-label",
          for: `${__props.formRef}-${name.value}`
        }, [
          createTextVNode(toDisplayString(__props.labelText) + " ", 1 /* TEXT */),
          (rules.value)
            ? (openBlock(), createElementBlock("span", _hoisted_2$2, "*"))
            : createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_1$2))
      : createCommentVNode("v-if", true),
    (__props.instructions)
      ? (openBlock(), createElementBlock("h6", _hoisted_3$2, toDisplayString(__props.instructions), 1 /* TEXT */))
      : createCommentVNode("v-if", true),
    (openBlock(), createBlock(resolveDynamicComponent(__props.as), mergeProps({
      id: `${__props.formRef}-${name.value}`,
      class: {
        'form-control': __props.as !== 'select' && __props.as !== 'div',
        'form-select': __props.as === 'select',
        'form-control-lg': __props.bigField || __props.bigForm,
        'is-valid': unref(meta).valid && unref(meta).validated,
        'is-invalid': !!unref(errorMessage) && unref(meta).validated,
      },
      rows: __props.as === 'textarea' ? '4' : null,
      multiple: __props.multiple ? __props.multiple : null,
      value: __props.as === 'input' || __props.as === 'textarea' ? unref(inputValue) : null,
      type: __props.as === 'input' ? __props.type : null,
      name: 
        __props.as === 'input' || __props.as === 'select' || __props.as === 'textarea' ? name.value : null
      ,
      placeholder: __props.as === 'input' || __props.as === 'textarea' ? __props.placeholder : null
    }, toHandlers(
        __props.as === 'input' || __props.as === 'textarea'
          ? { input: unref(handleChange), blur: unref(handleBlur) }
          : { change: unref(handleChange) }
      )), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "inside", {
          meta: unref(meta),
          errorMessage: unref(errorMessage)
        })
      ]),
      _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["id", "class", "rows", "multiple", "value", "type", "name", "placeholder"])),
    withDirectives(createElementVNode("p", {
      class: normalizeClass([__props.isFeedBackTooltip ? 'invalid-tooltip' : 'invalid-feedback'])
    }, toDisplayString(unref(errorMessage)), 3 /* TEXT, CLASS */), [
      [vShow, unref(errorMessage)]
    ])
  ], 2 /* CLASS */))
}
}

};

script$2.__file = "src/components/DynamicInput.vue";

const _hoisted_1$1 = {
  class: "form-check",
  style: {"display":"inline-block","margin-right":"1em"}
};
const _hoisted_2$1 = ["id", "type", "name", "value"];
const _hoisted_3$1 = ["for"];
const _hoisted_4$1 = {
  key: 1,
  class: "invalid-tooltip"
};


var script$1 = {
  __name: 'DynamicRadioCheck',
  props: {
  childAttrs: {
    type: Object,
    default: () => {},
  },
  formRef: {
    type: String,
    default: '',
  },
  labelText: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  nameChild: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

// a computed ref
const inputId = computed(() => {
  return `${props.formRef}-${props.nameChild}-${props.value}`;
});

const { nameChild, type, value } = toRefs(props);

const rules =
  type.value === 'checkbox'
    ? Yup.array().min(1).of(Yup.string().required()).required()
    : Yup.string().required();

const configObject =
  type.value === 'checkbox'
    ? {
        type: 'checkbox',
        checkedValue: value,
      }
    : {
        initialValue: '',
      };

const { errorMessage, handleChange, meta } = useField(
  nameChild,
  rules,
  configObject
);
// validationSchema={Yup.object().shape({
//   radioGroup: Yup.string().required("A radio option is required"),
//   checkboxGroup: Yup.array().required(
//     "At least one checkbox is required"
//   ),
//   singleCheckbox: Yup.bool().oneOf([true], "Must agree to something")
// })}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("input", mergeProps({
      id: inputId.value,
      class: "form-check-input",
      type: unref(type),
      name: unref(nameChild),
      value: unref(value)
    }, __props.childAttrs, {
      class: {
        'is-valid': unref(meta).valid && unref(meta).validated,
        'is-invalid': !!unref(errorMessage) && unref(meta).validated,
      }
    }, toHandlers({ change: unref(handleChange) }, true)), null, 16 /* FULL_PROPS */, _hoisted_2$1),
    (__props.labelText !== '')
      ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: "form-check-label",
          for: inputId.value
        }, toDisplayString(__props.labelText), 9 /* TEXT, PROPS */, _hoisted_3$1))
      : createCommentVNode("v-if", true),
    (unref(errorMessage))
      ? (openBlock(), createElementBlock("span", _hoisted_4$1, toDisplayString(unref(errorMessage)), 1 /* TEXT */))
      : createCommentVNode("v-if", true)
  ]))
}
}

};

script$1.__file = "src/components/DynamicRadioCheck.vue";

const _hoisted_1 = ["id"];
const _hoisted_2 = {
  key: 0,
  class: "pt-5 text-primary"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "form-check" };
const _hoisted_6 = ["id"];
const _hoisted_7 = ["for"];
const _hoisted_8 = /*#__PURE__*/createElementVNode("p", null, [
  /*#__PURE__*/createTextVNode(" He leído y acepto las "),
  /*#__PURE__*/createElementVNode("a", {
    class: "ml-2 fw-bold",
    href: "/politica-de-privacidad"
  }, "políticas de privacidad y protección de datos")
], -1 /* HOISTED */);
const _hoisted_9 = { class: "d-grid py-4" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = ["value"];
const _hoisted_12 = ["disabled"];


// eslint-disabled
const __default__ = {
  name: 'DynamicForm',
};
// eslint-enable


var script = /*#__PURE__*/Object.assign(__default__, {
  props: {
  schema: {
    type: Array,
    required: true,
  },
  formRef: {
    type: String,
    default: '',
  },
  saveFirebase: {
    type: Boolean,
    default: false,
  },
  sendEmail: {
    type: Boolean,
    default: false,
  },
  secondary: {
    type: Boolean,
    default: false,
  },
  bigForm: {
    type: Boolean,
    default: false,
  },
  firebaseCollection: {
    type: String,
    default: 'contactForm',
  },
  firebaseConfig: {
    type: Object,
    default: () => {
      return { ...defaultConfig };
    },
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  formName: {
    type: String,
    default: 'defaultForm',
  },
},
  emits: ['formBuilderOnSubmit'],
  setup(__props, { emit: __emit }) {

// import VueRecaptcha from 'vue-recaptcha';
const { handleSubmit, isSubmitting, resetForm } = useForm();

const props = __props;

const emit = __emit;

const formProcessed = ref(false);
const privacyPolicyCheck = ref(false);
const saveFirebase = toRef(props, 'saveFirebase');
const sendEmail = toRef(props, 'sendEmail');
const isLoading = toRef(props, 'isLoading');
const formRef = toRef(props, 'formRef');
const userData = reactive({
  data: {},
});

function resetState() {
  formProcessed.value = false;
  resetForm();
}

async function sendEmailAction(formData) {
  try {
    await axios({
      method: 'post',
      url: '/inc/_php.php',
      data: formData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    });
    formProcessed.value = true;
    console.info('Email is sent');
  } catch (error) {
    console.error('Error sending email: ', error);
  }
}

async function addDataToFirebase() {
  const contactRef = getFirebaseCollection(props.firebaseCollection);
  try {
    // Add a new document with a generated id.
    const docRef = await addDoc(contactRef, userData.data);
    if (docRef) {
      formProcessed.value = true;
      console.info('Data added, doc written with ID: ', docRef.id);
    }
  } catch (err) {
    console.warn(err);
  }
}

function onInvalidSubmit() {
  // TODO disable button
  // const submitBtn = document.querySelector('.submit-btn')
  // submitBtn.classList.add('invalid')
  // setTimeout(() => {
  //   submitBtn.classList.remove('invalid')
  // }, 1000)

  // const validate = useValidateForm()
  // try {
  //   await validate()
  //   //
  // } catch (error) {
  // }
  if (process.client) {
    const firstErrorParent = document.getElementById(formRef.value);
    const firstError = firstErrorParent.querySelectorAll('.is-invalid');
    if (firstError.length !== 0) {
      firstError[0].focus();
      firstError[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }
}

const onSubmit = handleSubmit((values) => {
  let formData;
  if (process.client) {
    formData = new FormData(document.getElementById(formRef.value));
  }

  // for (var pair of formData.entries()) {
  //   console.log(pair[0] + ', ' + pair[1])
  // }

  // formData.set('g-recaptcha-response', recaptchaToken);

  // TODO create a mixin for the captcha
  // execute recaptcha
  // self.$refs.recaptcha.execute();
  // this.onCaptchaVerified();
  formData.forEach(function (value, key) {
    if (
      key === 'inputFormName' ||
      key === 'inputImages' ||
      key === 'status' ||
      key === 'privacyPolicyCheck'
    ) {
      userData.data[key] = value;
    }

    // avoid add recaptcha-response and inputDays[] to the object
    // if (key != 'g-recaptcha-response' && key != 'inputDays[]') {
    //   vm.userData[key] = value;
    // }
  });

  // add timestamp to the object
  userData.data.timestamp = serverTimestamp();

  for (const [key, value] of Object.entries(values)) {
    userData.data[key] = value;
  }
  if (saveFirebase.value) {
    isLoading.value = true;
    addDataToFirebase();
    isLoading.value = false;
  }

  if (sendEmail.value) sendEmailAction(formData);
  // Emit data to parent component
  emit('formBuilderOnSubmit', userData.data);
}, onInvalidSubmit);

// TODO add recaptcha

// onCaptchaExpired() {
//       this.$refs.recaptcha.reset();
//     }
// onCaptchaVerified(recaptchaToken) {},

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["formBuilder", [__props.secondary ? 'formBuilder--secondary' : 'formBuilder--primary']])
  }, [
    (_ctx.$slots.loader && isLoading.value)
      ? renderSlot(_ctx.$slots, "loader", { key: 0 })
      : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          (formProcessed.value && !unref(isSubmitting))
            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                renderSlot(_ctx.$slots, "thankyou", {
                  userData: userData.data
                }),
                (_ctx.$slots.submitAgainText)
                  ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: "btn btn-primary",
                      onClick: resetState
                    }, [
                      renderSlot(_ctx.$slots, "submitAgainText")
                    ]))
                  : createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createElementVNode("form", {
                  id: formRef.value,
                  class: "row",
                  onSubmit: _cache[1] || (_cache[1] = (...args) => (unref(onSubmit) && unref(onSubmit)(...args))),
                  onInvalidSubmit: onInvalidSubmit
                }, [
                  renderSlot(_ctx.$slots, "headingSection"),
                  renderSlot(_ctx.$slots, "introSection"),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.schema, (section, index) => {
                    return (openBlock(), createElementBlock(Fragment, {
                      key: `key${index}`
                    }, [
                      (section.title !== '')
                        ? (openBlock(), createElementBlock("h5", _hoisted_2, toDisplayString(section.title), 1 /* TEXT */))
                        : createCommentVNode("v-if", true),
                      (section.description !== '')
                        ? (openBlock(), createElementBlock("p", _hoisted_3, toDisplayString(section.description), 1 /* TEXT */))
                        : createCommentVNode("v-if", true),
                      (openBlock(true), createElementBlock(Fragment, null, renderList(section.fields, ({
                as,
                name,
                labelText = '',
                half,
                rules,
                multiple,
                type,
                bigField,
                children,
                ...attrs
              }) => {
                        return (openBlock(), createElementBlock("div", {
                          key: `key${name}`,
                          class: normalizeClass([half ? 'col-md-6' : '', 'col-12'])
                        }, [
                          createVNode(script$2, mergeProps({
                            as: as,
                            name: name,
                            labelText: labelText,
                            multiple: multiple,
                            rules: rules,
                            type: type,
                            bigForm: __props.bigForm,
                            bigField: bigField,
                            formRef: formRef.value
                          }, attrs), createSlots({ _: 2 /* DYNAMIC */ }, [
                            (children && children.length)
                              ? {
                                  name: "inside",
                                  fn: withCtx(() => [
                                    (openBlock(true), createElementBlock(Fragment, null, renderList(children, ({
                        tag,
                        type: typeChild = null,
                        value = null,
                        labelText: labelTextChild = '',
                        name: nameChild = null,
                        ...childAttrs
                      }, idx) => {
                                      return (openBlock(), createElementBlock(Fragment, { key: idx }, [
                                        (typeChild === 'checkbox' || typeChild === 'radio')
                                          ? (openBlock(), createBlock(script$1, {
                                              key: 0,
                                              formRef: formRef.value,
                                              type: typeChild,
                                              labelText: labelTextChild,
                                              nameChild: nameChild,
                                              value: value,
                                              childAttrs: childAttrs
                                            }, null, 8 /* PROPS */, ["formRef", "type", "labelText", "nameChild", "value", "childAttrs"]))
                                          : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                              createCommentVNode(" <option value=\"\" disabled selected>\n                          {{ placeholder }}\n                        </option>\n                        <option\n                          v-for=\"(item, index) in items\"\n                          :key=\"index\"\n                          :value=\"item.value\"\n                        >\n                          {{ item.text }}\n                        </option> "),
                                              (openBlock(), createBlock(resolveDynamicComponent(tag), mergeProps({ value: value }, childAttrs), {
                                                default: withCtx(() => [
                                                  createTextVNode(toDisplayString(labelText), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["value"]))
                                            ], 64 /* STABLE_FRAGMENT */))
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["as", "name", "labelText", "multiple", "rules", "type", "bigForm", "bigField", "formRef"])
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  createElementVNode("div", _hoisted_4, [
                    createElementVNode("div", _hoisted_5, [
                      withDirectives(createElementVNode("input", {
                        id: `${formRef.value}-privacyPolicyCheck`,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((privacyPolicyCheck).value = $event)),
                        class: "form-check-input",
                        type: "checkbox",
                        name: "privacyPolicyCheck"
                      }, null, 8 /* PROPS */, _hoisted_6), [
                        [vModelCheckbox, privacyPolicyCheck.value]
                      ]),
                      createElementVNode("label", {
                        class: "form-check-label",
                        for: `${formRef.value}-privacyPolicyCheck`
                      }, [
                        renderSlot(_ctx.$slots, "privacyPolicy", {}, () => [
                          _hoisted_8
                        ])
                      ], 8 /* PROPS */, _hoisted_7)
                    ]),
                    createElementVNode("div", _hoisted_9, [
                      (_ctx.$slots.hiddenInputs)
                        ? (openBlock(), createElementBlock("div", _hoisted_10, [
                            renderSlot(_ctx.$slots, "hiddenInputs")
                          ]))
                        : createCommentVNode("v-if", true),
                      createElementVNode("input", {
                        type: "hidden",
                        name: "inputFormName",
                        value: __props.formName
                      }, null, 8 /* PROPS */, _hoisted_11),
                      createElementVNode("button", {
                        class: normalizeClass(["btn submit-btn", [
                  __props.secondary ? 'btn-secondary' : 'btn-primary',
                  __props.bigForm ? 'btn-lg' : '',
                  { disabled: !privacyPolicyCheck.value },
                ]]),
                        type: "submit",
                        disabled: !privacyPolicyCheck.value
                      }, [
                        renderSlot(_ctx.$slots, "submitText")
                      ], 10 /* CLASS, PROPS */, _hoisted_12)
                    ]),
                    createCommentVNode(" <vue-recaptcha\n                ref=\"recaptcha\"\n                @verify=\"onCaptchaVerified\"\n                @expired=\"onCaptchaExpired\"\n                size=\"invisible\"\n                badge=\"inline\"\n                sitekey=\"6LfoyF8UAAAAADgR_vDHmv5eSnqdJR8etDUtj1HG\"\n              ></vue-recaptcha> ")
                  ])
                ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
                (_ctx.$slots.footerSection)
                  ? renderSlot(_ctx.$slots, "footerSection", { key: 0 })
                  : createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

});

script.__file = "src/components/DynamicForm.vue";

var components = { DynamicForm: script };

const plugin = {
  install(Vue) {
    for (const prop in components) {
      if (Object.prototype.hasOwnProperty.call(components, prop)) {
        const component = components[prop];
        Vue.component(component.name, component);
      }
    }
  },
};

export { plugin as default };
